import React from 'react';

import Expand from '../../components/Expand';

import s from './index.module.css';

const Questions = () => {
  return (
    <section className={s.questionsSection}>
      <h2 className={s.questionsHeader}>Вопросы и ответы</h2>
      <div className={s.questions}>
        <Expand title="Какова задача эксперта Смартби?" defaultIsExpand={true}>
          <p>1. Принять обращение покупателя в чате в личном кабинете эксперта</p>
          <p>2. Выяснить, что ищет покупатель</p>
          <p>3. Подобрать парт-номер нужной детали</p>
          <p>4. Найти предложения продавцов на сайте Смартби</p>
          <p>5. Рассказать о вариантах покупателю</p>
          <p>6. Оформить заказ покупателю на Смартби</p>
        </Expand>

        <Expand title="Как рассчитывается вознаграждение?">
          <p>Ваше вознаграждение — <b>3%</b> от стоимости каждого оформленного вами заказа.</p>
          <p>Начисляется после выдачи заказа покупателю.</p>
          <p>Если покупателю не подходит товар и он его возвращает, вознаграждение отменяется.</p>
        </Expand>

        <Expand title="Как происходит выплата?">
          <p><b>Сейчас мы сотрудничаем только с индивидуальными предпринимателями.</b></p>
          <p>Вознаграждение выплачивается через банк два раза в месяц.</p>
          <p>Работаем по <a className={s.link} href="/agreement-seller">оферте</a>, в конце отчетного периода готовим вам акт и переводим вознаграждение на расчётный счёт.</p>
          <p>Всю статистику по продажам видно в личном кабинете эксперта после регистрации в режиме реального времени.</p>
        </Expand>

        <Expand title="Как подключиться?">
          <p>В Смартби работают настоящие эксперты.</p>
          <p>Чтобы подтвердить, что вы один из лучших — зарегистрируйтесь и пройдите короткий <a className={s.link} href="/Account/RegisterExpert">тест</a>.</p>
        </Expand>

        <Expand title="Как связаться со службой поддержки?">
          <p>После регистрации в личном кабинете будет доступен чат со специалистом службы поддержки.</p>
        </Expand>

        <Expand title="Что такое испытательный срок?">
          <p>Так как желающих много, а количество рабочих мест ограничено — все эксперты Смартби проходят испытательный срок.</p>
          <p>Это нужно, чтобы ограничить время знакомства с системой и понять: сколько времени вы можете уделять консультациям.</p>
          <p>Во время испытательного срока точно также выплачиваем вознаграждение за каждый оформленный заказ без каких либо ограничений.</p>
        </Expand>

        <Expand title="Сколько длится испытательный срок и что нужно делать?">
          <p><b>За 5 дней после регистрации нужно оформить не менее 5 заказов</b></p>
          <p>Для настоящего профессионала это не проблема — каждый эксперт Смартби в среднем оказывает более 100 консультаций в день и оформляет 10-15 заказов.</p>
          <p>Если не пройдёте испытательный срок — выплатим вознаграждение, но будем вынуждены вас отключить.</p>
          <p>Общайтесь с покупателями, будьте вежливы, проявляйте участие. И продажи не заставят себя ждать.</p>
        </Expand>

        <Expand title="У меня еще вопрос">
          <p>Если появились вопросы — пишите в службу поддержки на эл.почту <a className={s.link} href="mailto:help@smartbe.com">help@smartbe.com</a>, вместе всё решим!</p>
        </Expand>
      </div>
    </section>
  );
}

export default Questions;
